import { render } from "./SmartTab.vue?vue&type=template&id=98f8b424"
import script from "./SmartTab.vue?vue&type=script&lang=js"
export * from "./SmartTab.vue?vue&type=script&lang=js"

import "./SmartTab.vue?vue&type=style&index=0&id=98f8b424&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__